var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elgroup"},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(_vm._s(_vm.icon))]),(_vm.label)?_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }